import { useState, useCallback } from 'react';

export default function useModal(initialState = false) {
    const [isOpen, setIsOpen] = useState(initialState);

    const toggle = useCallback((e) => {
        if (typeof e === 'boolean') {
            setIsOpen(e);
        } else {
            e?.preventDefault?.();
            setIsOpen((prevIsOpen) => !prevIsOpen);
        }
    }, []);

    const show = useCallback((e) => {
        e?.preventDefault?.();

        setIsOpen(true);
    }, []);

    const hide = useCallback((e) => {
        e?.preventDefault?.();

        setIsOpen(false);
    }, []);

    const props = {
        onClose: hide,
        isOpen,
    };

    return { isOpen, toggle, show, hide, props };
}
